import { colors } from '@constants/colors';

export const useStyles = () => ({
  fullscreen: {
    display: 'none',
    position: 'absolute',
    top: 180,
    right: 50,
    zIndex: 343443434334433,
    '& svg': {
      color: colors.myta,
    },
  },
  fullscreenCollapse: {
    display: 'none',
    position: 'absolute',
    top: 180,
    right: 20,
    zIndex: 343443434334433,
    '& svg': {
      color: colors.myta,
    },
  },
});
